// extracted by mini-css-extract-plugin
module.exports = {"table":"GoodsCategory_table__1uYv9","label":"GoodsCategory_label__1hLng","value":"GoodsCategory_value__1qQxy"};